import {computed, ref} from 'vue';

const webViewData = ref({});
const fromWebView = computed(() => webViewData.value?.from ?? false);
const webViewClass = computed(() => webViewData.value?.className ?? '');

function setWebView(data) {
  webViewData.value = data;
}

export function useWebView() {
  return {
    setWebView,
    fromWebView,
    webViewClass,
  };
}
